import { useState, useCallback } from "react";
import { productService } from "../services/productService";

export const useProductDealers = () => {
  const [dealerPrices, setDealerPrices] = useState([]); // Bayi fiyat listesi
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDealerPrices = useCallback(async (productId, districtId) => {
    // districtId null olabilir veya geçerli bir ID olmalı
    if (!productId) {
      console.warn("fetchDealerPrices: productId eksik.");
      setDealerPrices([]); // productId yoksa temizle
      return;
    }
    // districtId yoksa API'ye gitmeden boş döndür (veya API null kabul ediyorsa null gönder)
    if (!districtId) {
      console.warn("fetchDealerPrices: districtId eksik.");
      setDealerPrices([]); // districtId yoksa temizle
      return;
    }

    setLoading(true);
    setError(null);
    setDealerPrices([]); // Yeni istek başlarken temizle
    try {
      const pricesData = await productService.getDealerPricesForProduct(
        productId,
        districtId
      );
      console.log("useProductDealers - Gelen Dealer Prices Data:", pricesData);
      setDealerPrices(pricesData); // Gelen diziyi state'e ata
      return pricesData;
    } catch (err) {
      setError(err.message || "Bayi fiyatları getirilemedi");
      console.error("Bayi fiyatları getirme hatası:", err);
      setDealerPrices([]); // Hata durumunda temizle
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    dealerPrices,
    loading,
    error,
    fetchDealerPrices,
  };
};

export default useProductDealers;
